import { PaymentOption } from '@/models/company';
import { Contact } from '@/models/contact';
import { Credit } from '@/models/credit';
import { CRMLinking, Customer, CustomerGroup, PaymentActivation, ServiceZone, Zone } from '@/models/customer';
import { CustomerContact } from '@/models/customerContact';
import { CustomerStats } from '@/models/customerStats';
import { CustomerStatus } from '@/models/customerStatus';
import { CustomerTag } from '@/models/customerTag';
import { LicenseType } from '@/models/licenseType';
import { Task } from '@/models/task';

export interface CRMState {
  customers: Customer[];
  contacts: Contact[];
  customerContacts: CustomerContact[];
  customerGroups: CustomerGroup[];
  credits: Credit[];
  crmLinkings: CRMLinking[];
  licenseTypes: LicenseType[];
  activatedPaymentsCustomers: PaymentActivation[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  paymentTerms?: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  priceSchedules?: any[];
  paymentOptions?: PaymentOption[];
  serviceZones: ServiceZone[];
  statuses?: CustomerStatus[];
  stats?: CustomerStats;
  tags?: CustomerTag[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  templates?: any[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tiers?: any[];
  tasks: Task[];
  zones: Zone[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  zips?: any[];
  isLoadingCustomers: boolean;
  isLoadingContacts: boolean;
  isLoadingCustomerContacts: boolean;
  isLoadingCredits: boolean;
  isLoadingTasks: boolean;
  isLoadingZones: boolean;
  isLoadingGroups: boolean;
}

export const state: CRMState = {
  licenseTypes: [],
  customers: [],
  contacts: [],
  crmLinkings: [],
  customerContacts: [],
  customerGroups: [],
  credits: [],
  zones: [],
  zips: [],
  activatedPaymentsCustomers: [],
  paymentTerms: [],
  statuses: [],
  stats: {},
  tags: [],
  tiers: [],
  tasks: [],
  paymentOptions: [],
  serviceZones: [],
  isLoadingCustomers: false,
  isLoadingContacts: false,
  isLoadingCustomerContacts: false,
  isLoadingCredits: false,
  isLoadingTasks: false,
  isLoadingZones: false,
  isLoadingGroups: false,
};
